/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon20Light = forwardRef('ArrowDUturnUpRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.485.628a.5.5 0 1 0-.67.744l3.968 3.57c.02.019.04.038.058.058H9.5a6.5 6.5 0 1 0 0 13h4a.5.5 0 1 0 0-1h-4a5.5 5.5 0 1 1 0-11h6.34a.764.764 0 0 1-.057.057l-3.967 3.571a.5.5 0 0 0 .668.744L16.453 6.8a1.75 1.75 0 0 0 0-2.602L12.484.63Z" })));
});
